import { render, staticRenderFns } from "./ArrayPaging.vue?vue&type=template&id=f49283de&"
import script from "./ArrayPaging.vue?vue&type=script&lang=js&"
export * from "./ArrayPaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports